import Navigation from "./Navigation";
import Footer from "./Footer";
import ToastContainer from "../ui/ToastContainer";
import ChatbotWidgetLazy from "../ChatbotWidgetLazy";
import AccountStatusGuard from "../auth/AccountStatusGuard";
import { useToast } from "../../contexts/ToastContext";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { toasts, removeToast } = useToast();
  
  // Get KoreAI API key from environment variable
  const koreAIKey = import.meta.env.VITE_KOREAI_API_KEY;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navigation />
      <main className="flex-1">
        <AccountStatusGuard>{children}</AccountStatusGuard>
      </main>
      <Footer />
      <ToastContainer toasts={toasts} onRemove={removeToast} />
      
      {/* KoreAI Chatbot — only load when API key is configured */}
      {koreAIKey && (
        <ChatbotWidgetLazy apiKey={koreAIKey} position="bottom-right" />
      )}
    </div>
  );
} 